import React from 'react';
import {
  PrimaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';

import { UserContext } from '@zola-helpers/client/dist/es/@types';

import {
  HorizontalNavWrapper,
  ScrollWrapper,
  SecondaryAndQuickLinksWrapper,
} from './HorizontalNav.styles';
import AnnouncementBanner from '../AnnouncementBanner/AnnouncementBanner';
import QuickLinks from '../QuickLinks/QuickLinks';
import SecondaryNav from '../SecondaryNav/SecondaryNav';
import TertiaryNav from '../TertiaryNav/TertiaryNav';
import UtilityBar from '../UtilityBar/UtilityBar';

type HorizontalNavProps = {
  activeLinkId?: '' | PrimaryNavIdentifier;
  activeSecondaryLink: string;
  activeUniversalTab: string;
  hideAnnouncementBanner: boolean;
  hideContentOnScroll: boolean;
  isHomeStoreActive: boolean;
  secondaryNavData: SecondaryNavItem[];
  tertiaryNavData: SecondaryNavItem[];
  userContext?: UserContext;
  quickLinksData?: SecondaryNavItem[];
  activeTertiaryLink?: string;
};

const HorizontalNav = ({
  activeLinkId,
  activeSecondaryLink,
  activeUniversalTab,
  hideAnnouncementBanner,
  hideContentOnScroll,
  isHomeStoreActive,
  secondaryNavData,
  tertiaryNavData,
  userContext,
  quickLinksData,
  activeTertiaryLink,
}: HorizontalNavProps): JSX.Element => {
  const showSecondaryNav = secondaryNavData.length > 0;
  const showTertiaryNav = tertiaryNavData.length > 0;

  return (
    <HorizontalNavWrapper>
      {hideAnnouncementBanner ? null : (
        <AnnouncementBanner hideContentOnScroll={hideContentOnScroll} />
      )}
      <ScrollWrapper hideContentOnScroll={hideContentOnScroll} showSecondaryNav={showSecondaryNav}>
        <UtilityBar
          hideContentOnScroll={hideContentOnScroll}
          activeLinkId={activeLinkId}
          activeSecondaryLink={activeSecondaryLink}
          activeUniversalTab={activeUniversalTab}
          isHomeStoreActive={isHomeStoreActive}
          showSecondaryNav={showSecondaryNav}
          userContext={userContext}
        />
        {showSecondaryNav && (
          <SecondaryAndQuickLinksWrapper hideContentOnScroll={hideContentOnScroll}>
            <SecondaryNav
              secondaryNavData={secondaryNavData}
              activeSecondaryLink={activeSecondaryLink}
            />
            {quickLinksData && quickLinksData?.length !== 0 && (
              <QuickLinks
                quickLinksData={quickLinksData}
                hideContentOnScroll={hideContentOnScroll}
                activeLinkId={activeLinkId}
              />
            )}
          </SecondaryAndQuickLinksWrapper>
        )}
        {showTertiaryNav && (
          <TertiaryNav tertiaryNavData={tertiaryNavData} activeTertiaryLink={activeTertiaryLink} />
        )}
      </ScrollWrapper>
    </HorizontalNavWrapper>
  );
};

export default HorizontalNav;
